
export const dashboardBreadCumbs = [
    {
        text: 'Voxel 3DI',
        active: true,
    },
    {
        text: 'Dashboard',
        active: true,
    },
]

export const accountSettingsBreadCrumbs = [
    {
        text: 'Dashboard',
        to: {path: '/dashboard/page=1'},
    },
    {
        text: 'Account Settings',
        active: true,
    },
]

export const checkoutBreadCrumbs = [
    {
        text: 'shop',
        to: {path: '/shop/page=1'},
    },
    {
        text: 'shoping cart',
        to: {path: 'shopping-cart'},
    },
    {
        text: 'checkout',
        active: true,
    },
]

export const checkoutPaymentCompleteBreadCrumbs = [
    {
        text: 'Shop',
        to: {path: '/shop/page=1'},
    },
    {
        text: 'Check out',
        to: {path: '/checkout'},
    },
    {
        text: 'Payment Complete',
        active: true,
    },
]

export const dealsAndOffersBreadCrumbs = [
    {
        text: 'Dashboard',
        to: {path: '/dashboard/page=1'},
    },
    {
        text: 'Deals and Offers',
        active: true,
    },
]

export const emptyShoppingCartBreadCrumbs = [
    {
        text: 'Shop',
        to: {path: '/shop/page=1'},
    },
    {
        text: 'Shopping Cart',
        active: true,
    },
]

export const helpCenterBreadCrumbs = [
    {
        text: 'dashboard',
        to: {path: '/dashboard/page=1'},
    },
    {
        text: 'help Center',
        active: true,
    },
]

export const myOrdersBreadCrumbs = [
    {
        text: 'dashboard',
        to: {path: '/dashboard/page=1'},
    },
    {
        text: 'My Orders',
        active: true,
    },
]

export const myPatienBreadCrumbs = [
    {
        text: 'dashboard',
        to: {path: '/dashboard/page=1'},
    },
    {
        text: 'my patients',
        active: true,
    },
]

export const continueServiceFlowBreadCrumbs = [
    {
        text: 'Dashboard',
        to: {path: '/dashboard/page=1'},
    },
    {
        text: 'Existing Services',
        to: {path: '/start-service-existing/page=1'},
    },
    {
        text: 'Continue Service Flow',
        active: true,
    },
]

export const newServiceFlowShipmentBreadCrumbs = [
    {
        text: 'shop',
        to: {path: '/shop/page=1'},
    },
    {
        text: 'start new service',
        active: true,
    },
]

export const patienServicesBreadCrumbs = [
    {
        text: 'dashboard',
        to: {path: '/dashboard/page=1'},
    },
    {
        text: 'my patients',
        to: {path: '/my-patients'},
    },
    {
        text: 'checkout',
        active: true,
    },
]

export const placeOrderBreadCrumbs = [
    {
        text: 'Shop',
        to: {path: '/shop/page=1'},
    },
    {
        text: 'Shoping Cart',
        to: {path: '/shopping-cart'},
    },
    {
        text: 'Checkout',
        to: {path: '/checkout'},
    },
    {
        text: 'Confirm Payment',
        active: true,
    },
]

export const productDetailBreadCrumbs = [
    {
        text: 'Shop',
        to: {path: '/shop/page=1'},
    },
]

export const serverDownBreadCrumbs = [
    {
        text: 'Shop',
        to: {path: '/shop/page=1'},
    },
    {
        text: 'Shopping Cart',
        active: true,
    },
]

export const shopBreadCrumbs = [
    {
        text: 'Dashboard',
        to: {path: '/dashboard/page=1'},
    },
    {
        text: 'Shop',
        active: true,
    },
]

export const shopingCartBreadCrumbs = [
    {
        text: 'Shop',
        to: {path: '/shop/page=1'},
    },
    {
        text: 'Shopping Cart',
        active: true,
    },
]

export const startCephServiceAnalysisBreadCrumbs = [
    {
        text: 'Dashboard',
        to: {path: '/dashboard/page=1'},
    },
    {
        text: 'Start Service',
        to: {path: '/start-service-existing/page=1'},
    },
    {
        text: 'AI - Ceph Analysis',
        active: true,
    },
]

export const startPanoramaServiceAnalysisBreadCrumbs = [
    {
        text: 'Dashboard',
        to: {path: '/dashboard/page=1'},
    },
    {
        text: 'Start Service',
        to: {path: '/start-service-existing/page=1'},
    },
    {
        text: 'Panoramic Analysis',
        active: true,
    },
]

export const startDigitalServiceBreadCrumbs = [
    {
        text: 'Dashboard',
        to: {path: '/dashboard/page=1'},
    },
    {
        text: 'Shop',
        to: {path: '/shop/page=1'},
    },
    {
        text: 'Start New Digital Service',
        active: true,
    },
]

export const startNewAIServiceBreadCrumbs = [
    {
        text: 'Dashboard',
        to: {path: '/dashboard/page=1'},
    },
    {
        text: 'New AI Service',
        active: true,
    },
]

export const startNewCephServicePatienBreadCrumbs = [
    {
        text: 'shop',
        to: {path: '/shop/page=1'},
    },
    {
        text: 'new service',
        active: true,
    },
]

export const startNewCephServicePaymentCompleteBreadCrumbs = [
    {
        text: 'shop',
        to: {path: '/shop/page=1'},
    },
    {
        text: 'New Service',
        active: true,
    },
]

export const startServiceExistingBreadCrumbs = [
    {
        text: 'Dashboard',
        to: {path: '/dashboard/page=1'},
    },
    {
        text: 'Start Existing Service',
        active: true,
    },
]

export const internalDoctorDashboardBreadCumbs = [
    {
        text: 'Voxel 3DI',
        active: true,
    },
    {
        text: 'Internal Doctor',
        active: true,
    },
    {
        text: 'Dashboard',
        active: true,
    },
]

export const internalDoctorChatsBreadCumbs = [
    {
        text: 'Voxel 3DI',
        active: true,
    },
    {
        text: 'Internal Doctor',
        active: true,
    },
    {
        text: 'My Chats',
        active: true,
    },
]

export const internalDoctorServiceSummeryBreadCumbs = [
    {
        text: 'Dashboard',
        to: {path: '/internal-doctor/dashboard/page=1'},
    },
    {
        text: 'Service Summery',
        active: true,
    },
]